import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle as MuiDialogTitle,
  DialogContent,
  IconButton,
  Typography,
  makeStyles
} from "@material-ui/core";
import axios from "axios";
import { Close as CloseIcon } from "@material-ui/icons";
import config from "../config";

const useStylesDialogTitle = makeStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2)
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500]
  }
}));

/* eslint-disable no-param-reassign */
const DialogTitle = props => {
  const { children, onClose } = props;
  const classes = useStylesDialogTitle();

  return (
    <MuiDialogTitle disableTypography className={classes.root}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
};

const PoliciesViewer = ({ policiesViewerRef }) => {
  const [privacyPolicy, setPrivacyPolicy] = useState("");
  const [openPrivacyPolicy, setOpenPrivacyPolicy] = useState(false);
  const [cookiePolicy, setCookiePolicy] = useState("");
  const [openCookiePolicy, setOpenCookiePolicy] = useState(false);

  useEffect(async () => {
    const privacyPolicy = await axios(config.iubendaPrivacyPolicyApiUrl);
    setPrivacyPolicy(privacyPolicy.data?.content);
  });

  useEffect(async () => {
    const cookiePolicy = await axios(config.iubendaCookiePolicyApiUrl);
    setCookiePolicy(cookiePolicy.data?.content);
  });

  policiesViewerRef.current.setOpenPrivacyPolicy = setOpenPrivacyPolicy;
  policiesViewerRef.current.setOpenCookiePolicy = setOpenCookiePolicy;

  return (
    <>
      <Dialog
        fullWidth
        maxWidth="lg"
        open={openPrivacyPolicy}
        onClose={() => {
          setOpenPrivacyPolicy(false);
        }}
        aria-labelledby="privacy-policy-dialog"
      >
        <DialogTitle
          id="customized-dialog-title"
          onClose={() => {
            setOpenPrivacyPolicy(false);
          }}
        >
          Privacy Policy
        </DialogTitle>
        <DialogContent dividers>
          <div dangerouslySetInnerHTML={{ __html: privacyPolicy }} />
        </DialogContent>
      </Dialog>

      <Dialog
        fullWidth
        maxWidth="lg"
        open={openCookiePolicy}
        onClose={() => {
          setOpenCookiePolicy(false);
        }}
        aria-labelledby="cookie-policy-dialog"
      >
        <DialogTitle
          id="customized-dialog-title"
          onClose={() => {
            setOpenCookiePolicy(false);
          }}
        >
          Cookie Policy
        </DialogTitle>
        <DialogContent dividers>
          <div dangerouslySetInnerHTML={{ __html: cookiePolicy }} />
        </DialogContent>
      </Dialog>
    </>
  );
};

PoliciesViewer.defaultProps = {
  policiesViewerRef: { current: {} }
};

export default PoliciesViewer;
